import { ConfigService } from '../../config';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../../config/config.service";
var AuthHttpService = /** @class */ (function () {
    function AuthHttpService(configService) {
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    AuthHttpService.prototype.authConfirmed = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/auth-confirmed';
            var params = {
                body: {}
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    AuthHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthHttpService_Factory() { return new AuthHttpService(i0.ɵɵinject(i1.ConfigService)); }, token: AuthHttpService, providedIn: "root" });
    return AuthHttpService;
}());
export { AuthHttpService };
